import qs from 'qs';

export type CalendlyUser = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
};

export type GetRecurringChildcareCalendlyUrlFunc = (user: CalendlyUser) => string;

export const getRecurringChildcareCalendlyUrl: GetRecurringChildcareCalendlyUrlFunc = ({
  firstName,
  lastName,
  email,
  phone,
}) => {
  const params = qs.stringify({ name: `${firstName} ${lastName}`, email, a1: phone });
  return `https://calendly.com/wecasa/presentation-garde-d-enfants-wecasa/?${params}`;
};

export const getRecurringChildcareZohoUrl = (zoho_name: string) =>
  `https://survey.zohopublic.com/zs/VACNXc?zoho_name=${zoho_name}`;

export const getOrderRecurringChildcareModificationZohoUrl = (orderZohoId: string) =>
  `https://survey.zohopublic.com/zs/1OEXS8?fromservice=ZCRM&zs_salesorders=${orderZohoId}`;
